import { startCase } from 'lodash';
import isBox44Path from './isBox44Path';

const BOX_44_TITLE = 'Additional Documents and References (Box 44)';

/**
 * The label of a field the form parser cannot name. Box 44 is edited in a modal rather than a card, so
 * it is named after the modal - with the document code when the entry is keyed by one (H1), but not
 * with a position (H7 keeps its entries in a list). Anything else shows its last named segment in
 * words, so a card never shows a dotted path.
 */
const getFallbackFieldLabel = (path: string, box44Path?: string): string => {
    if (isBox44Path(path, box44Path)) {
        const entryKey = path.slice(box44Path.length + 1).split('.')[0];
        const isDocumentCode = !!entryKey && isNaN(Number(entryKey));
        return isDocumentCode ? `${BOX_44_TITLE} · ${entryKey}` : BOX_44_TITLE;
    }

    const lastNamedSegment = path
        .split('.')
        .filter((segment) => segment && isNaN(Number(segment)))
        .at(-1);
    return lastNamedSegment ? startCase(lastNamedSegment) : 'Unknown field';
};

export default getFallbackFieldLabel;
